import { combineReducers } from "@reduxjs/toolkit"
import notifieesReducer from "./notifiees.slice"
import workMonitorViewsReducer from "./workMonitorViews.slice"

const OrganizationReducer = combineReducers({ notifiees: notifieesReducer, workMonitorViews: workMonitorViewsReducer })

export default OrganizationReducer
